const memberpractices = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Member Practices",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4",
        children: [
          {
            title: "Member Practices",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Member Practices",
                submit_url: "/api/categories/$currentCategoryId/pages",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Practice Title",
                    placeholder: "Enter Practice Title",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  practice_image: "",
                  website_url: "",
                  call_the_practice_toggle: false,
                  phone_number: "",
                  address: "",
                  // "slug": "",
                  // "media_type":"None",
                  // "image_url":"",
                  // "video_url":"",
                  // "upload_type": "",
                  // "upload_url": "",
                },
              },
            },
            children: [
              {
                type: "memberPracticesTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Practice Title",
                  type: "list",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style: "",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "Practice Title",
                      placeholder: "Enter Practice Title",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    picture: {
                      type: "imgSelect",
                      label: "Select Image",
                      placeholder: "Select Image",
                      // "displayOn": "media_type",
                      // "displayOnValue": 'Image',
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    website_url: {
                      type: "text",
                      label: "Website URL",
                      placeholder: "Enter Website URL",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    call_the_practice_toggle: {
                      type: "toggle",
                      label: "Call the practice",
                      size: "12",
                      required: false,
                    },
                    phone_number: {
                      type: "text",
                      label: "Phone Number",
                      placeholder: "Phone Number",
                      displayOn: "call_the_practice_toggle",
                      displayOnValue: "true",
                      required: false,
                      info: false,
                      character_count: 10,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    address: {
                      type: "text",
                      label: "Address",
                      placeholder: "Enter Address",
                      displayOn: "call_the_practice_toggle",
                      displayOnValue: "true",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { memberpractices };
